import { API_URL_SSO_START } from '../../../api/constants'
import { LoginResponseStatus } from '../../../api/authentication/AuthenticationContext'

export const SSO_ERROR_QUERY_KEY = 'sso_error'

// Same rule the password form uses (Login.tsx); one source of truth for both entry points.
export const EMAIL_RE = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i
export const isValidEmail = (value: string): boolean => EMAIL_RE.test(value.trim())

export const ssoStartUrl = (email: string): string =>
  `${API_URL_SSO_START}?email=${encodeURIComponent(email.trim().toLowerCase())}`

const MESSAGES: Record<string, string> = {
  unknown_domain: 'Single sign-on is not enabled for that email domain. Sign in with your email/password, or contact your administrator.',
  no_account: 'Your organization signed you in, but there is no PathSpot account for that email. Ask your PathSpot administrator to add you.',
  inactive: 'Your PathSpot account is inactive. Ask your PathSpot administrator to reactivate it.',
  auth_failed: 'Single sign-on could not complete. Please try again from this page.',
  flow_expired: 'That sign-in link expired or was not started from PathSpot. Please start again from this page.',
}

export const ssoErrorMessage = (code: string | null): string | null => {
  if (code === null || code === undefined || code === '') return null
  return MESSAGES[code] ?? 'Single sign-on could not complete. Please try again.'
}

export const classifyLoginError = (err: unknown): LoginResponseStatus => {
  const e = err as { status?: number; json?: { Code?: string }; text?: string } | null
  if (!e || e.status !== 403) return LoginResponseStatus.fail
  let code = e.json?.Code
  if (!code && typeof e.text === 'string') {
    try {
      code = (JSON.parse(e.text) as { Code?: string }).Code
    } catch {
      /* not json */
    }
  }
  return code === 'SsoRequiredError' ? LoginResponseStatus.ssoRequired : LoginResponseStatus.fail
}
